import { VideoGame } from "@/interfaces/api";
import { MdVideogameAsset, MdDateRange } from "react-icons/md";
import { Badge } from "./shadcn/badge";
import { cn } from "@/lib/utils";

interface VideoGameListItemProps {
  game: VideoGame;
  onClick: () => void;
}

export default function VideoGameListItem({
  game,
  onClick,
}: VideoGameListItemProps) {
  const releaseYear = new Date(game.first_release_date * 1000).getFullYear();

  return (
    <li
      key={game.id}
      className={cn(
        "transition",
        "duration-500",
        "scale-95",
        "hover:scale-100",
        "focus:bg-deep-purple-600/80",
        "active:bg-deep-purple-600/80",
        "hover:bg-deep-purple-700/80",
        "focus:text-white",
        "active:text-white",
        "hover:text-white",
        "p-2",
        "rounded-sm",
        "cursor-pointer"
      )}
      onClick={onClick}
    >
      <div className="flex w-full">
        {game.name}
        <div className="flex gap-1 ml-auto">
          <Badge
            className="text-center gap-1"
            color="deep-purple"
            title={`Game launched on ${game.platforms.length} platform(s)`}
          >
            {game.platforms.length}
            <MdVideogameAsset className="h-4 w-4" />
          </Badge>
          <Badge className="text-center gap-1" color="deep-purple">
            {releaseYear}
            <MdDateRange className="h-4 w-4" />
          </Badge>
        </div>
      </div>
    </li>
  );
}
